import { Tooltip, makeStyles } from '@material-ui/core'
import '@styles/Typography/style.css'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { stores } from '@stores'
import { useTranslation } from 'react-i18next'
import { getProductAttributeValue } from '@utils/get-product-attribute-value'
import { useObserver } from 'mobx-react-lite'
import { CentricTypography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import Typography from '@components/std-components/Typography'

const useStyles = makeStyles(theme => ({
  typographyMenuList: {
    margin: 0,
    textTransform: 'capitalize',
    color: ' rgba(0, 0, 0, 0.87)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: 0
  },
  withChildrenMenuList: {
    marginTop: -12
  },
  enhancedTypographyMenuList: {
    marginTop: 0
  },
  enhancedBackground: {
    backgroundColor: 'white'
  },
  typographyFontWeight: {
    fontWeight: 500
  }
}))

const NavNodeName: React.FC<any> = ({
  node,
  showLoading,
  isEnhancedViewEnabled,
  hasChildren
}): JSX.Element => {
  return useObserver(function useHook() {
    const classes = useStyles({ hasChildren })
    const {
      productConfiguration: { findSpecificAttribute, defaultValuesFromConfig = {} }
    } = stores

    const { t } = useTranslation()
    let toolTip = ''
    const attributeObj = findSpecificAttribute(node?.attributeId)
    if (isEnhancedViewEnabled && attributeObj) {
      toolTip = t(`${attributeObj?.labelKey}`, attributeObj?.displayName)
    }
    const nodeText = getProductAttributeValue(
      node,
      attributeObj,
      isEnhancedViewEnabled,
      defaultValuesFromConfig
    )

    return (
      <Tooltip title={toolTip}>
        <div>
          {isEnhancedViewEnabled ? (
            <CentricTypography
              variant={node?.variant ?? 'h5'}
              className={classNames(
                classes.typographyMenuList,
                classes.enhancedTypographyMenuList,
                classes.enhancedBackground,
                {
                  [classes.typographyFontWeight]: hasChildren && node?.variant === 'h5'
                }
              )}
            >
              {showLoading ? <Skeleton /> : nodeText}
            </CentricTypography>
          ) : (
            <Typography
              variant={'title'}
              color={'primary'}
              classes={classNames(classes.typographyMenuList, {
                [classes.withChildrenMenuList]: hasChildren
              })}
            >
              {showLoading ? <Skeleton /> : nodeText}
            </Typography>
          )}
        </div>
      </Tooltip>
    )
  })
}

export default NavNodeName
